<template>
  <section>
    <div class="modal__header text--center">
      <div class="modal__header__titulo">Consecutivo</div>
    </div>
    <div class="modal__body text">
      <p>
        <span>{{ params.consecutivo }}-</span>
        <span class="text--rojo">{{modelo}}</span>
      </p>
      <div class="mt-4">
        <input
          v-model="modelo"
          class="form__input"
          ref="inputSufijo"
          required
        >
        <label class="form__label">Ingrese el consecutivo</label>
      </div>
    </div>
    <div class="modal__footer">
      <button
        type="button"
        class="boton boton--cancelar"
        @click="hideModal"/>
      <button
        type="button"
        class="boton boton--primario"
        :disabled="!modelo"
        @click="continuar">
        <i class="fa fal fa-check"/>
        <span class="text">Continuar</span>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      modelo: null,
    };
  },
  computed: {
    params() {
      return this.$store.state.modal.params;
    },
  },
  mounted() {
    this.modelo = this.params.sufijo;
    this.$refs.inputSufijo.focus();
  },
  methods: {
    hideModal() {
      return this.$store.commit(this.$actions.hideModal);
    },
    continuar() {
      const resp = `${this.params.consecutivo}-${this.modelo}`;
      this.hideModal();
      this.params.continuar(resp);
    },
  },
};
</script>

<style>

</style>
